import * as React from 'react';
export const danaSvg = React.forwardRef(function danaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Z',
      fill: '#008CEB',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.992 16.05v3.378c0 .22-.094.266-.279.158a6.172 6.172 0 0 0-.769-.391 5.216 5.216 0 0 0-2.525-.336c-.934.121-1.852.351-2.733.685-.88.297-1.74.618-2.637.866a7.341 7.341 0 0 1-2.29.301 4.86 4.86 0 0 1-2.417-.753.595.595 0 0 1-.288-.532V12.79c0-.108 0-.235.097-.29.096-.055.195.035.279.09.787.532 1.72.808 2.67.79a7.118 7.118 0 0 0 1.995-.37c.914-.284 1.797-.66 2.696-.979.7-.268 1.417-.489 2.147-.659a4.662 4.662 0 0 1 3.676.68.806.806 0 0 1 .385.718v3.296l-.007-.015Z',
      fill: '#FEFEFE',
    }),
  );
});
danaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dana = {
  category: 'brand',
  colorable: false,
  name: 'dana',
  svg: danaSvg,
};
